import { HTMLAttributes, ReactNode, SyntheticEvent } from 'react';

import { twMerge } from 'tailwind-merge';

import { EventMykissCardClicked } from '../../../interfaces/events';

import { sendCardClickedEvent } from './sendCardClickedEvent';

interface CardButtonProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  eventProperties: EventMykissCardClicked['properties'];
  onClick?: (event: SyntheticEvent) => void;
  ariaLabel: string;
}

export const CardButton = ({
  children,
  className,
  disabled,
  eventProperties,
  onClick,
  ariaLabel,
  ...rest
}: CardButtonProps) => {
  const handleOnClick = (event: SyntheticEvent): void => {
    if (onClick) {
      onClick(event);
    }
    sendCardClickedEvent(eventProperties);
  };

  return (
    <button
      type="button"
      className={twMerge('p-0 *:h-full! *:w-full!', className)}
      disabled={disabled}
      onClick={handleOnClick}
      aria-label={ariaLabel}
      {...rest}
    >
      {children}
    </button>
  );
};
